import ConfirmationDialog from 'core/components/ConfirmationDialog'
import { getDeleteConfirmText } from 'core/components/CRUDListContainer'
import React, { useState, useMemo } from 'react'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { deleteClusterHostGroup } from './actions'

const DeleteClusterHostGroupsDialog = ({ rows, onClose }) => {
  const [error, setError] = useState(null)

  const {
    update: deleteClusterHostGroupFn,
    updating: deletingClusterHostGroup,
    error: deleteError,
  } = useUpdateAction(deleteClusterHostGroup)

  const deleteConfirmText = useMemo(() => getDeleteConfirmText(rows), [rows])

  const handleSubmit = async () => {
    const promises = []
    for (const cluster of rows) {
      promises.push(
        deleteClusterHostGroupFn({
          name: cluster?.name,
        }),
      )
    }

    const resonse = await Promise.all(promises)
    if (resonse.every((res) => res.success)) {
      onClose()
    } else {
      setError({
        title: 'Error Deleting Clusters',
        message: 'One or more cluster failed to delete',
      })
    }
  }

  return (
    <ConfirmationDialog
      text={deleteConfirmText}
      onConfirm={handleSubmit}
      onCancel={onClose}
      error={deleteError || error}
      loading={deletingClusterHostGroup}
      open
    />
  )
}

export default DeleteClusterHostGroupsDialog
